function BackIcon(props) {
    return (
        <svg
            width={10}
            height={16}
            viewBox="0 0 10 16"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M8.734 1.205a.795.795 0 00-1.065 0L1.44 6.989a1.33 1.33 0 000 1.98l6.273 5.826a.795.795 0 001.057.007.666.666 0 00.009-.997l-5.74-5.331a.665.665 0 010-.99l5.695-5.29a.664.664 0 000-.99"
                stroke={`${props.fill || '#000'}`}
                strokeWidth={0.2}
                fillRule="evenodd"
            />
        </svg>
    );
}

export default BackIcon;
